import { useEffect, useState } from 'react'
import { getPlansAuthBasic } from '../services'
import { IResponseGetPlans } from '../../interfaces/src'

export const useGetPlansAuthBasic = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [plans, setPlans] = useState<IResponseGetPlans | null>(null)
  const [isError, setIsError] = useState(false)

  const fetchPlans = async () => {
    setIsLoading(true)
    try {
      const response = await getPlansAuthBasic()
      if (response.isSuccess && response.data) {
        setPlans(response?.data)
        setIsError(false)
      } else {
        setIsError(true)
      }
    } catch {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!plans && !isError && !isLoading) {
      fetchPlans()
    }
  }, [plans])

  return {
    fetchPlans,
    isLoading,
    plans,
    isError
  }
}
